module.exports = __webpack_public_path__ + "assets/img/bp_d_i_10.7995ec0f.jpg";